@if (!readonly) {
  <mat-radio-group [class.multi-line]="question.alternatives.length > 2"
    [id]="question.id"
    [value]="question.answer">
    @for (alternative of question.alternatives; track alternative) {
      <mat-radio-button
        [aria-label]="alternative.text"
        (change)='alternativeSelections.next(alternative)'
      [value]="alternative.id">{{alternative.text}}</mat-radio-button>
    }
  </mat-radio-group>
}

@if (readonly) {
  <div  class="form-control" readonly style="width:auto; display: inline-block; margin-bottom:10px;">
    <span>{{ selectedAlternativeText }}</span>
  </div>
}

<app-collapsible  [trigger]="question.wrongAlternative">
  <p class="form-error" >
    You must meet this requirement to continue your application.
  </p>
</app-collapsible>

@for (alternative of question.alternatives; track alternative) {
  <app-collapsible [trigger]="selectedAlternative === alternative"
    >
    @for (followup of alternative.questions; track followup) {
      <app-followup-question [readonly]="readonly" [question]="followup" [form]="form">
      </app-followup-question>
    }
  </app-collapsible>
}

<app-collapsible [trigger]="$safeNavigationMigration(selectedAlternative?.showAdditionalInfo)">
  <div class="important registrant-message">
    You must <a href="http://pharmacyregulation.org/registration/changes-your-registration/something-declare" target="_blank">tell us about this by filling in a <span class="italics">something to declare form</span></a>. We will use the information you give us in the form to assess if you are fit to practise and if you meet the criteria to
    register as a pharmacist.
  </div>
</app-collapsible>